import { useContext, useMemo } from "react";
import { UserContext } from "contexts/UserContext/UserContext";
import { CircularProgress } from "@mui/material";
import { EventReportsEntity } from "entities/EventReports/EventReportsEntity";
import { IEventReportDetails } from "entities/EventReports/EventReportsEntityInterfaces";
import { OPERATOR_EXCEPTIONS } from "constants/constants";
import { DetailsReportEditionContext } from "contexts/DetailsReportEditionContext/DetailsReportEditionContext";
import { DropdownOptions, IOption } from "../Dropdown";

export const OperatorDropdown = ({ row }: { row: IEventReportDetails }) => {
    const { user_id } = useContext(UserContext);
    const { edit, setEdit } = useContext(DetailsReportEditionContext);

    const existingEdition = useMemo(() => edit.findIndex((event) => event.id === row.event_report_id), [edit, row]);
    const selectedOperatorId = useMemo(
        () =>
            edit[existingEdition]?.changes?.user_id === row?.user_operator?.user_id &&
            row?.user_operator?.code === OPERATOR_EXCEPTIONS.NO_OPERATOR
                ? undefined
                : edit[existingEdition]?.changes?.user_id,
        [edit, existingEdition, row],
    );
    const { loading, operators } = EventReportsEntity.GetOperatorsForEventEdition(
        row.machine_center.machine_center_id,
        row.cluster_id,
    );

    const operatorOptions: IOption[] = useMemo(
        () => operators.map((el) => ({ name: `${el.user.first_name} ${el.user.last_name}`, id: el.user.user_id })),
        [operators],
    );

    const handleFunctionalLocationUpdate = async (id: number) => {
        if (existingEdition !== -1) {
            setEdit((prevEdit) => {
                const newEdit = [...prevEdit];
                newEdit[existingEdition] = {
                    ...newEdit[existingEdition],
                    changes: {
                        ...newEdit[existingEdition]?.changes,
                        user_id: id,
                        ...(user_id && { edited_by_user_id: user_id }),
                    },
                };
                return newEdit;
            });
        }
    };

    return loading ? (
        <CircularProgress size={20} color="info" />
    ) : (
        <DropdownOptions
            inlineStyle={{ width: "80px" }}
            optionSelected={selectedOperatorId}
            options={operatorOptions}
            handleUpdate={handleFunctionalLocationUpdate}
        />
    );
};
